import moment from "moment";

// check is not empty
export const isNotEmpty = (obj: any): boolean => {
  return obj !== null && obj !== undefined && obj !== 0 && obj.length !== 0;
};

// captilizing
export const capitalizeString = (str: string): string => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// sort by value
export const sortedByNumber = (obj: { order: number }[]): { order: number }[] => {
  return obj.sort((a, b) => a.order - b.order);
}

// compare two arrays
export const twoArryDifference = (
  array1: { category_id: number }[],
  array2: { id: number }[]
): { category_id: number }[] => {
  return array1.filter((object1) => {
    return !array2.some((object2) => {
      return object1.category_id === object2.id;
    });
  });
};

export const dataFromat = (start: string | null, end: string | null): boolean => {
  const dateString1 = end != null ? end : '30/12/2022 00:00';
  const dateString2 = start != null ? start : '20/09/2022 00:00';

  const [day1, month1, year1, time1] = dateString1.split(/[\s/:]+/);
  const [day2, month2, year2, time2] = dateString2.split(/[\s/:]+/);

  const isoDateString1 = `${year1}-${month1}-${day1}T${time1}:00`;
  const isoDateString2 = `${year2}-${month2}-${day2}T${time2}:00`;

  const isLarger = new Date(isoDateString1) > new Date(isoDateString2);
  return isLarger;
};

// convert into rgba format
export const colorRGB = (hexColor: string): string => {
  const red = parseInt(hexColor.slice(1, 3), 16);
  const green = parseInt(hexColor.slice(3, 5), 16);
  const blue = parseInt(hexColor.slice(5, 7), 16);
  const opacity = 0.5;
  const rgbaColor = `rgba(${red}, ${green}, ${blue}, ${opacity})`;
  return rgbaColor;
};

// get difference time between current with starting or ending time
export const compareStartAndEndTime = (
  days: string[] = [],
  start: string,
  end: string
): boolean => {
  let show = false;
  const weekday = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const current = new Date();
  const currentDay = weekday[current.getDay()];
  let flag = false;

  if (days.length > 0) {
    flag = days.includes(currentDay);
  } else {
    flag = true;
  }

  if (flag) {
    const starting = new Date();
    starting.setHours(Number(start.split(":")[0]));
    starting.setMinutes(Number(start.split(":")[1]));

    const ending = new Date();
    ending.setHours(Number(end.split(":")[0]));
    ending.setMinutes(Number(end.split(":")[1]));

    if (starting.toString() !== ending.toString()) {
      if (starting > ending) {
        if (current < starting && current < ending) {
          starting.setDate(starting.getDate() - 1);
        } else {
          ending.setDate(ending.getDate() + 1);
        }
      }

      if (starting <= current && current <= ending) {
        show = true;
      }
    }
  } else {
    show = true;
  }

  return show;
};

export const checkExpire = (end_at: any): boolean => {
  const currentTime = moment();
  const endTime = moment(end_at);

  // Check if the current time is before the end time
  return currentTime.isBefore(endTime);
};

export const handlePastDaysText = (value:any) => {
  var day = value;
   var result;
   switch (day) {
      case 0 :
         result = `Today`;
         break;
      case 2:
         result = `Yesterday`;
         break;
      default:
         result = `Ago`;
         break;
   }
} 

export const formatTime = (hour: number): string => {
  // Ensure the hour is within the valid range (0 - 23)
  const formattedHour = (hour % 24 + 24) % 24;

  // Determine whether it's AM or PM
  const period = formattedHour < 12 ? 'AM' : 'PM';

  // Convert to 12-hour format
  const formattedHour12 = formattedHour % 12 || 12;

  // Combine the formatted time
  const formattedTime = `${formattedHour12}:00 ${period}`;

  return formattedTime;
};




export const  convertTo12HourFormat = (time24: string): string => {
  // Split the time into hours and minutes
  const [hours, minutes] = time24.split(':');

  // Convert hours to 12-hour format
  let hours12 = (parseInt(hours, 10) % 12) || 12; // Handle midnight (0 hours)

  // Determine AM/PM
  const period = parseInt(hours, 10) < 12 ? 'AM' : 'PM';

  // Return the time in 12-hour format with AM/PM
  return `${hours12}:${minutes} ${period}`;
}


export const formatWithTimezone = (date: any) => {
  const offset = date.getTimezoneOffset(); // In minutes
  const offsetHours = Math.abs(offset / 60);
  const offsetMinutes = Math.abs(offset % 60);
  const sign = offset > 0 ? "-" : "+";
  return `${date.getFullYear()}-${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}-${date
    .getDate()
    .toString()
    .padStart(2, "0")}T${date
    .getHours()
    .toString()
    .padStart(2, "0")}:${date
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${date
    .getSeconds()
    .toString()
    .padStart(2, "0")}${sign}${offsetHours
    .toString()
    .padStart(2, "0")}:${offsetMinutes.toString().padStart(2, "0")}`;
};
